function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "v6",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "SoberOctober_3_mobile_expanded",
  transform: "translate(-28.000000, -1290.000000)",
  fill: "#C8C8C8",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-Copy-2",
  transform: "translate(20.000000, 1280.000000)"
}, React.createElement("g", {
  id: "thumbs-down",
  transform: "translate(8.000000, 10.000000)"
}, React.createElement("path", {
  d: "M3.5,0.253 L3.5,6.5 L1.25,6.5 C0.561,6.5 0,5.939 0,5.25 L0,1.25 C0,0.561 0.561,0 1.25,0 L2.75,0 C3.0315,0 3.2905,0.095 3.5,0.253 Z M12,4.625 C12,4.9255 11.881,5.2055 11.6745,5.412 C11.908,5.6675 12.027,6.01 11.9945,6.3665 C11.936,7.002 11.3635,7.5 10.6905,7.5 L7.602,7.5 C7.755,7.9645 8,8.816 8,9.5 C8,10.5845 7.0785,11.5 6.5,11.5 C5.9805,11.5 5.6095,11.2075 5.5935,11.1955 C5.5345,11.148 5.5,11.076 5.5,11 L5.5,9.305 L4.06,6.185 L4,6.1545 L4,0.7955 C4.407,0.6035 4.922,0.5 5.25,0.5 L9.8395,0.5 C10.384,0.5 10.8605,0.867 10.9725,1.3735 C11.03,1.634 10.9965,1.8965 10.882,2.1245 C11.2515,2.3105 11.5,2.691 11.5,3.125 C11.5,3.3015 11.4595,3.4715 11.3825,3.625 C11.752,3.811 12,4.1915 12,4.625 Z",
  id: "Combined-Shape"
})))));

var SvgThumbsDown = function SvgThumbsDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgThumbsDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-down.9e285b6e.svg";
export { ForwardRef as ReactComponent };